import { propsFilter } from './propsFilter';

angular.module('filters', []).filter('propsFilter', propsFilter);
